import codeBackground from "assest/code.jpg"
import mobileIcon from "assest/mobile.png"
import computerIcon from "assest/computer.png"
import meIcon from "assest/me.jpg"
import squareIcon from "assest/square.png"

// Logos/Icons
import craftsmanIcon from "assest/craftsmanLogo.jpg"
import bandhanIcon from "assest/bandhan.png"
import kiddoIcon from "assest/kiddo.png"
import heirshipIcon from "assest/heirship.png"

// New Official Logos
import jagoLogo from "assest/jago_logo.png"
import progressmatesLogo from "assest/progressmates_logo.png"
import greenchickchopLogo from "assest/greenchickchop_logo.png"

const ImageConstant = {
  CODE_BACKGROUND: codeBackground,
  MOBILE_ICON: mobileIcon,
  COMPUTER_ICON: computerIcon,
  ME_ICON: meIcon,
  SQUARE_ICON: squareIcon,

  // Logos/Icons
  CRAFTSMAN_IMAGE: craftsmanIcon,
  BANDHAN_IMAGE: bandhanIcon,
  KIDDO_ICON: kiddoIcon,
  HEIRSHIP_ICON: heirshipIcon,

  // New Official Logos
  JAGO_LOGO: jagoLogo,
  PROGRESSMATES_LOGO: progressmatesLogo,
  GREENCHICKCHOP_LOGO: greenchickchopLogo,
}

export default ImageConstant
